// extracted by mini-css-extract-plugin
module.exports = {"completed":"CourseCompleted_completed__3QK-O","notCompleted":"CourseCompleted_notCompleted__1ORBJ"};